import React from 'react';
import { Menu } from 'antd';

import usePageMenuInfo from '@src/layout/AdsMain/hooks/usePageMenuInfo';

const HeaderMenu = (props) => {
  const { pageMenuInfo, curPageLevelInfo } = usePageMenuInfo(props);

  // 页面层级信息中第一个为顶部菜单，菜单信息也是
  const [pageMenus] = pageMenuInfo;
  const curPageInfo = curPageLevelInfo.slice(-1)[0];

  const selectedKeys = [curPageLevelInfo[0]?.fullPath];

  const curPath = curPageInfo?.fullPath;

  function handleClickMenu(pageInfo) {
    const { fullPath, subPageSort } = pageInfo;

    if (fullPath === curPath) {
      return;
    }

    let jumpPath = fullPath;

    // 当为父级菜单时，使用子菜单第一个作为跳转链接
    if (subPageSort?.length) {
      jumpPath = subPageSort[0];
    }

    window.router.go(jumpPath, {
      tryRefresh: true,
    });
  }

  return pageMenus?.length ? (
    <div style={{ marginLeft: 34 }}>
      <>
        <Menu
          builtinPlacements={{
            bottomLeft: {
              points: ['tl', 'bl'],
              overflow: {
                adjustX: 1,
                adjustY: 1,
              },
              offset: [-16, 10],
            },
          }}
          selectedKeys={selectedKeys}
          disabledOverflow
          mode="horizontal"
        >
          {pageMenus.map((pageConfig) => (
            <Menu.Item
              key={pageConfig.fullPath}
              onClick={() => handleClickMenu(pageConfig)}
              style={{ lineHeight: 'auto' }}
              className={`ads-wkd-layout-menu-item ffpm`}
            >
              {pageConfig.name}
            </Menu.Item>
          ))}
        </Menu>
      </>
    </div>
  ) : null;
};
export default HeaderMenu;
